import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageWithHeader from '../common/PageWithHeader';

// Verification is done by the app-level PaymentReturnHandler; this page only avoids the 404.
const PaymentReturn: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/', { replace: true }), 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <PageWithHeader>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 12, gap: 2 }}>
        <CircularProgress />
        <Typography variant="h6">Confirming your payment...</Typography>
      </Box>
    </PageWithHeader>
  );
};

export default PaymentReturn;
